import { Fetcher } from '@this/src/util';
import type { PriceResultArgs, PriceResultResponseArgs } from './prices_api';
import { convertPriceResultResponseToArgs } from './prices_api';

export type FetchCurPricesResponseArgs = {
  success: boolean;
  prices: PriceResultResponseArgs[];
  errors?: string[];
};

export type FetchCurPricesArgs = {
  success: boolean;
  prices: PriceResultArgs[];
  errors?: string[];
};

export type FetchCurPricesSubmitArgs = {
  from_airport: string;
  to_airport: string;
  target_date: string;
  source: 'skyticket' | 'travelko';
  search_query_id?: number | null;
  transit_ids?: string[];
};

export const convertFetchCurPricesResponseToArgs = (response: FetchCurPricesResponseArgs): FetchCurPricesArgs => ({
  success: response.success,
  prices: response.prices.map(convertPriceResultResponseToArgs),
  errors: response.errors
});

export const fetchDomesticAirCurPrices = async (params: FetchCurPricesSubmitArgs): Promise<FetchCurPricesArgs> => {
  const response = await Fetcher.post<FetchCurPricesResponseArgs>('/domestic_air_cur_prices', params);
  return convertFetchCurPricesResponseToArgs(response);
};
